module.exports = __webpack_public_path__ + "img/mb_section5-2.78449751.png";